import { createContext, useContext, useReducer } from 'react';
import { useParams } from 'react-router-dom';
import { BudgetUnitCreateEditState, BudgetUnitCreateEditReducer, ACTION_TYPES } from './budget-unit-create-edit-reducer';
export { ACTION_TYPES };

const BudgetUnitCreateEditContext = createContext<BudgetUnitCreateEditState | undefined>(undefined);
const BudgetUnitCreateEditDispatchContext = createContext({} as any);

export const BudgetUnitCreateEditProvider = ({ children }: { children: React.ReactNode }) => {
    const { budgetUnitId } = useParams();

    const initialState: BudgetUnitCreateEditState = {
        budgetUnitId,
        budgetUnitRequest: { year: new Date().getFullYear() },
        showValidationErrors: false,
    };

    const [state, dispatch] = useReducer(BudgetUnitCreateEditReducer, initialState);

    return (
        <BudgetUnitCreateEditContext.Provider value={state}>
            <BudgetUnitCreateEditDispatchContext.Provider value={dispatch}>
                {children}
            </BudgetUnitCreateEditDispatchContext.Provider>
        </BudgetUnitCreateEditContext.Provider>
    );
};

export const useBudgetUnitCreateEditState = () => {
    const context = useContext(BudgetUnitCreateEditContext);
    if (context === undefined) throw new Error('useBudgetUnitCreateEditState must be used within BudgetUnitCreateEditProvider');
    return context;
};

export const useBudgetUnitCreateEditDispatch = () => {
    const context = useContext(BudgetUnitCreateEditDispatchContext);
    if (context === undefined) throw new Error('useBudgetUnitCreateEditDispatch must be used within BudgetUnitCreateEditProvider');
    return context;
};
